/**
 * 重写Step组件dom节点
 * 1、重写标题
 * <Step v-resetDom="`<div>${title}</div><div>${time}</div>`" ...>
 * 2、重写内容
 * <Step v-resetDom:content="`<div>${time}</div><div>${context}</div>`" ...>
 */
export default {
  bind(el, binding) {
    if (binding.arg == 'content') { // 内容
      const titleNode = el.getElementsByClassName('ark-steps-main')[0].getElementsByClassName('ark-steps-content')
      titleNode[0].innerHTML = binding.value
    } else { // 标题
      const titleNode = el.getElementsByClassName('ark-steps-main')[0].getElementsByClassName('ark-steps-title')
      titleNode[0].innerHTML = binding.value
    }
  }
}
